"use client";

import { Form, Formik } from "formik";
import AuthPage from "@/app/(auth)/components/AuthPage";
import FormikInput from "@/ui/forms/FormikInput";
import React, { useState } from "react";
import { Button } from "@/ui";
import { useFirebaseContext } from "@/app/(auth)/components/FirebaseAuthContext";
import { getTenantInfo } from "@/lib/theme/tenant";
import { validatePasswordResetForm } from "@/app/(auth)/data";
import { AuthErrorCodes } from "firebase/auth";

export default function PasswordResetForm() {
    const auth = useFirebaseContext();
    const [hasSentPasswordReset, setHasSentPasswordReset] = useState(false)
    const tenantInfo = getTenantInfo()

    const sendPasswordReset = async ({ email }, helpers) => {
        helpers.setSubmitting(true)
        try {
            await auth.sendPasswordReset(email)
            setHasSentPasswordReset(true)
        } catch (e) {
            if (e.code === AuthErrorCodes.INVALID_EMAIL) {
                helpers.setFieldError('email', 'Invalid email address')
            }
        } finally {
            helpers.setSubmitting(false)
        }
    }

    return (
        <Formik<{ email: string }>
            initialValues={{ email: "" }}
            onSubmit={sendPasswordReset}
            validate={validatePasswordResetForm}
        >
            {(form) => (
                <AuthPage strapline={`Forgot your password?`}>
                    <h2 className="text-xl font-semibold font-poppins">
                        Reset your password
                    </h2>

                    { !hasSentPasswordReset && (
                        <>
                            <p className="text-base font-lato mt-1">
                                Enter your email to receive a link to reset your password
                            </p>

                            <Form>
                                <div className="space-y-8 my-8">
                                    <FormikInput
                                        id="email"
                                        name="email"
                                        type="email"
                                        label="Email Address"
                                    />
                                </div>

                                <div className="space-y-4">
                                    <Button
                                        id="auth-button"
                                        fill
                                        onClick={form.submitForm}
                                        disabled={form.isSubmitting}>
                                        Send password reset
                                    </Button>
                                    <Button
                                        fill
                                        variant="link"
                                        disabled={form.isSubmitting}
                                        href="/login">
                                        Go back
                                    </Button>
                                </div>
                            </Form>
                        </>
                    )}

                    { hasSentPasswordReset && (
                        <div className="space-y-8 mt-8 gap-2">
                            <p className="text-base font-lato">
                                If you have entered a valid email address, you should receive
                                your password reset email shortly.
                            </p>
                            <p className="text-base font-lato">
                                If you don&apos;t receive the email,
                                please ensure that you have entered your email correctly and try again.
                            </p>
                            <Button
                                fill
                                variant="link"
                                disabled={form.isSubmitting}
                                href="/login">
                                Go back
                            </Button>
                        </div>
                    )}
                </AuthPage>
            )}
        </Formik>
    )
}